import RestClient from '../rest_client/rest_client';

import { getObjectKeyPath } from '../utils/object_utils.js';

export default class DataStoreRouteLoader {
	load(dataStoreRoute, additionalParams={}) {
		return new Promise((resolve, reject) => {
			RestClient.performRequest(this.buildLoadRequestObject(dataStoreRoute, additionalParams)).then(
				this.handleLoadSuccess.bind(this, dataStoreRoute, resolve),
				reject
			);
		});
	}

	buildLoadRequestObject(dataStoreRoute, additionalParams) {
		const contextPath = window.contextPath || '';
		const request = {
			mime: 'application/json;charset=UTF-8',
			path: `${dataStoreRoute.noContextPath ? "" : contextPath}${dataStoreRoute.url}`,
			method: dataStoreRoute.httpMethod
		};

		const paramsKey = dataStoreRoute.httpMethod == "GET" ? 'params' : 'entity';
		request[paramsKey] = Object.assign({},
			this.parseDataStoreRouteParams(dataStoreRoute.params),
			additionalParams
		);

		return request;
	}

	parseDataStoreRouteParams(dataStoreRouteParams) {
		const parsedDataStoreRouteParams = {};
		dataStoreRouteParams.forEach((param) => {
			parsedDataStoreRouteParams[param.name] = param.value;
		});

		return parsedDataStoreRouteParams;
	}

	handleLoadSuccess(dataStoreRoute, resolve, response) {
		var resources = getObjectKeyPath(dataStoreRoute.resourceName, response.entity);
		var page = response.entity.page;
		resolve({ resources, page, response });
	}
}

export const dataStoreRouteLoader = new DataStoreRouteLoader();
